import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Typography } from '../Typography'
import { typographyVariants } from '../typography-variants'
import type { TGradientTypographyProps } from './gradientTypography.type'

const SpanWrapper = ({
  ariaRole,
  children,
  unaffectedChildren,
  classNameWrapper,
}: TGradientTypographyProps): ReactNode => {
  return (
    <Typography ariaRole={ariaRole} className={clsx('flex-1', classNameWrapper)}>
      {children}
      {unaffectedChildren}
    </Typography>
  )
}
export const GradientTypography = ({ ref, ...props }: TGradientTypographyProps) => {
  const {
    bold,
    black,
    center,
    colors,
    size,
    className,
    ariaRole,
    children,
    tabIndex,
    multicolor,
    unaffectedChildren,
    numberOfLines,
    heading,
  } = props

  const mainGradientContent = (
    <Typography
      ariaRole={(ariaRole ?? unaffectedChildren) ? 'span' : undefined}
      ref={ref}
      tabIndex={tabIndex}
      numberOfLines={numberOfLines}
      heading={heading}
      black={black}
      center={center}
      className={clsx(typographyVariants({ bold, colors, size, variant: 'gradient', multicolor }), className)}
    >
      {children}
    </Typography>
  )

  if (unaffectedChildren) {
    return <SpanWrapper {...props}>{mainGradientContent}</SpanWrapper>
  }
  return mainGradientContent
}
